import Select, { SelectProps } from 'antd/lib/select';
import React from 'react';
import { useQuery } from 'react-query';
import { getParameterDetail } from 'services/parametersService';

export type ParValueExternalSelectProps = SelectProps<any> & {
  parcode: string;
};

const ParValueExternalSelect = ({
  parcode,
  ...props
}: ParValueExternalSelectProps) => {
  const { data } = useQuery(
    ['getParameterDetail', parcode],
    () => getParameterDetail({ parcode }).then((res) => res.data as any),
    { staleTime: MINUTE }
  );

  return (
    <Select {...props}>
      {data?.parLists.map(
        ({
          parvalueexternal,
          parlistlabel,
          plistid,
        }: {
          parvalueexternal: string;
          parlistlabel: string;
          plistid: number;
        }) => (
          <Select.Option value={parvalueexternal} key={plistid}>
            {parlistlabel}
          </Select.Option>
        )
      )}
    </Select>
  );
};

const SECOND = 1000;
const MINUTE = 60 * SECOND;

export default ParValueExternalSelect;
